(() => {
  function setup(scope = document) {
    scope.querySelectorAll('[data-bw-image-open]').forEach(button => {
      if (button.dataset.ready) return;
      const dialog = document.getElementById(button.getAttribute('aria-controls'));
      if (!dialog || !dialog.showModal) { button.hidden = true; return; }
      button.dataset.ready = 'true';
      button.addEventListener('click', () => dialog.showModal());
      dialog.querySelector('[data-bw-image-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    });
  }
  setup(); document.addEventListener('shopify:section:load', event => setup(event.target));
})();
